export enum TipoEvento {
  EGRESADOS = "EGRESADOS",
  CUMPLEANIOS_BODAS = "CUMPLEANIOS_BODAS",
  FIESTAS = "FIESTAS",
}

export enum CategoriaInvitado {
  CENA = "CENA",
  BAILE = "BAILE",
  GENERAL = "GENERAL",
}
